import {isNew} from 'services/utils/editForm'
import {Page, PageContent} from 'components/Page'
import {FormProvider} from 'react-hook-form'
import {useI18n} from 'store/Store'
import {useParams} from 'react-router-dom'
import FormTitle from 'components/Page/Form/FormTitle'
import usePublicationFolderForm from 'logic/Forms/usePublicationFolderForm'
import PublicationFolderForm from 'components/Page/PublicationFolder/PublicationFolderForm'
import TableChart from '@mui/icons-material/TableChart'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import {useMemo, useRef} from 'react'

const EXCEL_ACCEPT =
    '.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

const PublicationFolder = () => {
    const {i18n} = useI18n()
    const {publicationFolderId} = useParams()
    const {form, submit, publicationFolder, uploadExcelFile, excelUploading} =
        usePublicationFolderForm(publicationFolderId)

    const excelFileInputRef = useRef(null)
    const excelUrl = form.watch('excelUrl')
    const hasExcelUrl = Boolean(excelUrl && String(excelUrl).trim().length > 0)

    const headerButtons = useMemo(() => {
        const buttons = [
            {
                key: 'addExcel',
                onClick: () => excelFileInputRef.current?.click(),
                label: i18n.t(
                    hasExcelUrl
                        ? 'publicationFolders.updateExcel'
                        : 'publicationFolders.addExcel'
                ),
                icon: <TableChart />,
                variant: 'outlined',
                disabled: excelUploading,
            },
        ]
        if (hasExcelUrl) {
            buttons.push({
                key: 'removeExcel',
                onClick: () =>
                    form.setValue('excelUrl', '', {
                        shouldDirty: true,
                        shouldValidate: true,
                    }),
                label: i18n.t('publicationFolders.removeExcel'),
                icon: <DeleteOutline />,
                variant: 'outlined',
                color: 'error',
                disabled: excelUploading,
            })
        }
        return buttons
    }, [i18n, excelUploading, hasExcelUrl, form])

    const handleExcelFileChange = (event) => {
        const file = event.target.files?.[0]
        event.target.value = ''
        if (file) {
            uploadExcelFile(file)
        }
    }

    return (
        <Page>
            <PageContent>
                <input
                    ref={excelFileInputRef}
                    type="file"
                    accept={EXCEL_ACCEPT}
                    style={{display: 'none'}}
                    onChange={handleExcelFileChange}
                />
                <FormTitle
                    itemId={publicationFolderId}
                    itemLabel={i18n.t(`tables.publicationFolder`)}
                    submit={submit}
                    buttons={headerButtons}
                />
                <FormProvider {...form}>
                    <PublicationFolderForm
                        publicationFolder={publicationFolder}
                        isNew={isNew(publicationFolderId)}
                    />
                </FormProvider>
            </PageContent>
        </Page>
    )
}

export default PublicationFolder
